if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.guardPreorderIdentity();
        this.syncVariantPurchaseState();
        this.preorderIdentityObserver = new MutationObserver(() => { this.guardPreorderIdentity(); this.syncVariantPurchaseState(); });
        this.preorderIdentityObserver.observe(this.form, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['class', 'name', 'value']
        });

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    static syncCardVariant(card, input) {
      const preorderText = input.dataset.rbPreorderText || '';
      const localStock = input.dataset.rbLocalStock === 'true';
      const stockLabel = localStock ? '' : input.dataset.rbStockText || preorderText;
      const variantUrl = new URL(input.dataset.rbProductUrl, window.location.origin);
      variantUrl.searchParams.set('variant', input.value);
      if (card) {
        card.dataset.rbStockLocal = String(localStock || !preorderText);
        card.dataset.rbSelectedVariant = input.value;
        card.querySelectorAll('.js-prod-link, .card__title a, .quick-add-view-btn').forEach((link) => { link.href = variantUrl.toString(); });
        const status = card.querySelector('.product-inventory__status');
        if (status && input.dataset.rbStockText && status.textContent.trim() !== input.dataset.rbStockText) status.textContent = input.dataset.rbStockText;
        let badge = card.querySelector('.rb-selected-variant-badge');
        if (!badge && stockLabel) {
          badge = document.createElement('span');
          badge.className = 'rb-selected-variant-badge product-label product-label--preorder absolute top-0 start-0';
          card.querySelector('.card__media')?.appendChild(badge);
        }
        if (badge) {
          badge.hidden = !stockLabel;
          if (badge.textContent !== stockLabel) badge.textContent = stockLabel;
        }
        const opener = card.querySelector('.js-quick-add');
        if (opener) opener.dataset.productUrl = variantUrl.toString();
        card.querySelectorAll('.restock-rocket-preorder-badge, .product-label--sold-out:not(.rb-selected-variant-badge), .product-label--preorder:not(.rb-selected-variant-badge)').forEach((label) => { label.style.display = 'none'; });
      }

    }

    syncVariantPurchaseState() {
      const input = this.form.querySelector('[name="id"]');
      if (!input?.dataset.rbProductId) return;
      const quickAdd = this.closest('quick-add-drawer');
      if (!quickAdd) return;
      const preorderText = input.dataset.rbPreorderText || '';
      const localStock = input.dataset.rbLocalStock === 'true';
      const button = this.form.querySelector('[name="add"]');
      if (button) {
        const text = preorderText || button.dataset.addToCartText;
        if (text && button.textContent.trim() !== text) button.textContent = text;
      }
      const variantUrl = new URL(input.dataset.rbProductUrl, window.location.origin);
      variantUrl.searchParams.set('variant', input.value);
      this.preorderDetailsUrl = preorderText ? variantUrl.toString() : null;
      const card = document.querySelector('product-card[data-product-id="' + input.dataset.rbProductId + '"]');
      ProductForm.syncCardVariant(card, input);
      let imageBadge = quickAdd.querySelector('.rb-quickadd-variant-badge');
      if (!imageBadge && preorderText) {
        imageBadge = document.createElement('span');
        imageBadge.className = 'rb-quickadd-variant-badge product-label product-label--preorder';
        quickAdd.querySelector('.quick-add-info__media')?.appendChild(imageBadge);
      }
      if (imageBadge) {
        imageBadge.hidden = !preorderText;
        if (imageBadge.textContent !== preorderText) imageBadge.textContent = preorderText;
      }
    }

    guardPreorderIdentity() {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      if (!variantId) return false;
      const fields = Array.from(this.form.querySelectorAll('.restock-rocket-form-input'));
      const markers = fields.map((field) => field.name.match(/^attributes\[__stoq_data_(\d+)\]$/)?.[1]).filter(Boolean);
      const labels = Array.from(this.form.querySelectorAll('[class*="restock-rocket-preorder-button-"]'));
      labels.forEach((label) => Array.from(label.classList).forEach((name) => {
        const marker = name.match(/^restock-rocket-preorder-button-(\d+)$/);
        if (marker) markers.push(marker[1]);
      }));
      const localStock = this.form.querySelector('[name="id"]')?.dataset.rbLocalStock === 'true';
      if (!markers.some((id) => id !== variantId) && !(localStock && fields.length)) {
        if (markers.length) this.preorderIdentityMismatch = false;
        return false;
      }
      fields.forEach((field) => field.remove());
      this.form.classList.remove('restock-rocket-form-updated');
      const button = this.form.querySelector('[name="add"]');
      labels.forEach((label) => {
        Array.from(label.classList).forEach((name) => {
          if (name.startsWith('restock-rocket-preorder-button')) label.classList.remove(name);
        });
        if (button?.dataset.addToCartText) label.textContent = button.dataset.addToCartText;
      });
      this.preorderIdentityMismatch = true;
      return true;
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      this.guardPreorderIdentity();
      this.syncVariantPurchaseState();
      if (this.preorderDetailsUrl) {
        window.location.assign(this.preorderDetailsUrl);
        return;
      }
      if (this.preorderIdentityMismatch && this.dataset.rbStoqLocalStock !== 'true' && this.form.querySelector('[name="id"]')?.dataset.rbLocalStock !== 'true') {
        const details = this.form.querySelector('.quick-add-view-btn');
        if (details) window.location.assign(details.href);
        return;
      }

      const selectedInput = this.form.querySelector('[name="id"]');
      if (selectedInput?.dataset.rbPreorderText && !this.form.querySelector('[name="selling_plan"]')?.value) {
        window._RestockRocket?.renderButtonForVariant?.(selectedInput.value);
        return;
      }
      this.submitBtn = this.querySelector('[name="add"]');

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
  const cardVariantRequests = new WeakMap();
  document.addEventListener('change', async (event) => {
    const swatch = event.target.closest('product-card .js-option[data-variant-id]');
    if (!swatch?.dataset.variantId) return;
    const card = swatch.closest('product-card');
    const link = card.querySelector('.js-prod-link, .card__title a');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('variant', swatch.dataset.variantId);
    const request = {};
    cardVariantRequests.set(card, request);
    try {
      const response = await fetch(url.toString());
      if (!response.ok || cardVariantRequests.get(card) !== request) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (cardVariantRequests.get(card) !== request) return;
      const selected = html.querySelector('.js-product-form-main [name="id"][data-rb-product-id]');
      if (selected && selected.value === swatch.dataset.variantId) ProductForm.syncCardVariant(card, selected);
    } catch (error) { console.debug(error); }
  });

}
